<template>
    <div v-if='editable'>
        <table class='bp mr-auto ml-auto w-100'>
            <thead>
                <tr>
                    <th style='text-align: center'>{{ $t('translations.systolic')}}</th>
                    <th>&nbsp;</th>
                    <th style='text-align: center'>{{ $t('translations.diastolic')}}</th>
                    <th style='text-align: center'>{{ $t('translations.priority')}}</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
        
            <template v-for='(item, index) in value'>
                <blood-pressure-range :index='index' :key='"" + index' :editable='editable' :value='item' />
            </template>
        
        </table>
        <button v-on:click='value.push({id: null})' class="btn btn-primary btn-round btn-sm mt-1 w-100">{{ $t('translations.add_blood_pressure_range')}}</button>
    </div>
    <table v-else class='bp mr-auto ml-auto'>
        <thead>
            <tr>
                <th style='text-align: center'>{{ $t('translations.systolic')}}</th>
                <th>&nbsp;</th>
                <th style='text-align: center'>{{ $t('translations.diastolic')}}</th>
                <th style='text-align: center'>{{ $t('translations.priority')}}</th>
            </tr>
        </thead>
        <tbody>
            <template v-if='value && value.length'>
                <tr :class='priorityClass(item.priority)' :key='index' v-for='(item, index) in value'>
                    <td style='text-align: center' v-text='item.systolic_min ? (item.systolic_min + " to " +  item.systolic_max) : ""'></td>
                    <td style='text-align: center' v-text='(item.relation_and ? "and" : "or")'></td>
                    <td style='text-align: center' v-text='item.diastolic_min ? (item.diastolic_min + " to " +  item.diastolic_max) : ""'></td>
                    <td style='text-align: center' v-text='$t("translations." + priorityName(item.priority))'></td>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td colspan='4' class='text-center'>{{$t('translations.no_blood_pressure_ranges')}}</td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        value: {
        },
        editable: {
            default: true,
        },
        errors: {
            default: function() {return []}
        }
    },
    data() {
        return {
            new_code: {},
        };
    },
    computed: {
        
    },
    watch: {
        
    },
    mounted() {
        
    },
    methods: {
        removeItem(index) {
            console.log(this.value, index);
            this.value.splice(index, 1);
        },
        priorityClass(priority) {
            switch(priority) {
                case -10: return "bg-lower"; break;
                case 5: return "bg-elevated"; break;
                case 10: return "bg-urgent"; break;
                case 20: return "bg-emergency"; break;
                default: return "bg-routine"; break;
            }
        },
        priorityName(priority) {
            switch(priority) {
                case -10: return "lower"; break;
                case 5: return "elevated"; break;
                case 10: return "urgent"; break;
                case 20: return "emergency"; break;
                default: return "routine"; break;
            }
        },
    },
};
</script>

<style scoped>
    .btn-clear {
        width: 22px; 
        height: 22px; 
        font-size: 13px; 
        padding: 0px;
        border: 1px solid #a0a0a0;
        border-radius: 0.25rem;
        font-weight: bold;
        color: rgb(120, 130, 140);
    }
</style>